package com.tixforgigs.common.core.util

import com.tixforgigs.apax.config.models.Flavor
import io.github.oshai.kotlinlogging.KotlinLoggingConfiguration
import io.github.oshai.kotlinlogging.Level

object LoggingUtil {

  fun configureRootLogLevel(flavor: Flavor) {
    KotlinLoggingConfiguration.direct.logLevel = when (flavor) {
      Flavor.PROD -> Level.OFF
      Flavor.BETA -> Level.ERROR
      Flavor.STAGING -> Level.WARN
      Flavor.DEV -> Level.INFO
      Flavor.LOCAL -> Level.TRACE
    }
  }
}
